module.exports = __webpack_public_path__ + "img/acord1-1.a5c3ebf0.png";